import { PageLink } from 'assets/layout/core'

export const breadcrumbUpdate: PageLink[] = [
  {
    title: 'Refeições',
    path: '/commercial/menuFoodTypes',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
